import React from 'react';

import * as formTypes from 'constants/formTypes';

import i18n from 'util/i18n';

import { Summary, DateSummary } from 'components/Summary';

import { LEGAL, LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM } from 'config/formSections/legal';

import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import OrganizationalItem from './OrganizationalItem';

const sectionConfig = {
  key: LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM.name,
  storeKey: LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM.storeKey,
};

export class InternationalAndDomesticTerrorism extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasInternationalAndDomesticTerrorism: this.props.HasInternationalAndDomesticTerrorism,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasInternationalAndDomesticTerrorism: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  render() {
    const { errors } = this.props;
    const subSectionName = 'internationalAndDomesticTerrorism';
    const sectionAssetPath = 'legal.pvq.associations';
    const subSectionAssetPath = `${sectionAssetPath}.${subSectionName}`;
    const subSectionClassName = subSectionAssetPath.replaceAll('.', '-');

    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    const summary = (item, index) => {
      const o = (item && item.Item) || {};
      const dates = DateSummary(o.Dates);
      const details = (o.Organization || {}).value || '';

      return Summary({
        type: i18n.t(`${subSectionAssetPath}.collection.item`),
        index,
        left: details,
        right: dates,
        placeholder: i18n.t(`${subSectionAssetPath}.collection.unknown`),
      });
    };

    return (
      <div
        className={`section-content ${subSectionClassName}`}
        data-section={LEGAL.key}
        data-subsection={LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM.key}
      >
        <h1 className="section-header">
          {i18n.t(`legal.pvq.subsection.associations.${subSectionName}`)}
        </h1>
        <Branch
          name="HasInternationalAndDomesticTerrorism"
          label={i18n.t(`${subSectionAssetPath}.hasInternationalAndDomesticTerrorism`)}
          labelSize="h4"
          className={`${subSectionClassName}-hasInternationalAndDomesticTerrorism`}
          {...this.props.HasInternationalAndDomesticTerrorism}
          warning
          onError={this.handleError}
          required={this.props.required}
          onUpdate={this.updateBranch}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasInternationalAndDomesticTerrorism"
        />

        <Show when={this.props.HasInternationalAndDomesticTerrorism.value === 'Yes'}>
          <Accordion
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            description={i18n.t(`${subSectionAssetPath}.collection.description`)}
            appendTitle={i18n.t(`${subSectionAssetPath}.collection.appendTitle`)}
            appendLabel={i18n.t(`${subSectionAssetPath}.collection.appendLabel`)}
            required={this.props.required}
            attribute="List"
            scrollIntoView={this.props.scrollIntoView}
          >
            <OrganizationalItem
              name="Item"
              attribute="List"
              bind
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              subSectionAssetPath={subSectionAssetPath}
              subSectionClassName={subSectionClassName}
              aware
              intended
              engaged
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

InternationalAndDomesticTerrorism.defaultProps = {
  name: 'international-and-domestic-terrorism',
  HasInternationalAndDomesticTerrorism: {},
  List: EmptyListInstance,
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'associations/international-and-domestic-terrorism',
  addressBooks: {},
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(InternationalAndDomesticTerrorism, sectionConfig);
